import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false })

const whiteList = ['/my', '/bookPreview']

router.beforeEach((to, from, next) => {
  NProgress.start()
  const urlParams = new URLSearchParams(window.location.search);
  if(urlParams.get("token") && process.env.VUE_APP_SSO_LOGIN == '1') {
    store.dispatch('newLogin', urlParams.get("token"))
  }
  const token = process.env.VUE_APP_SSO_LOGIN == '1' ? (urlParams.get("token") || getToken()) : getToken();
  if (token) {
    // to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch('GetInfo')
          .then(() => {
            isRelogin.show = false
            next({ ...to, replace: true })
            // store.dispatch('GenerateRoutes').then(accessRoutes => {
            //   // 根据roles权限生成可访问的路由表
            //   router.addRoutes(accessRoutes) // 动态添加可访问路由表
            //   next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            // })
          })
          .catch((err) => {
            console.log(err)
            store.dispatch('LogOut').then(() => {
              // Message.error(err)
              if(process.env.VUE_APP_SSO_LOGIN == '1') {
                window.location.href = `${process.env.VUE_APP_BASE_API}/oauth2/sso/logout?returnUrl=${location.origin}/index`;
              } else {
                next(`/index`)
              }
            })
          })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) === -1) {
      // if (true) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/index`) // 否则全部重定向到首页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
